import React from "react";
import line from "../assets/line.png";
import { motion } from "framer-motion";
import Innovation from "./Innovation";
import About2 from "../assets/About2.png";
import About3 from "../assets/About3.png";
import WiseFrameworkWithLines from "./WiseFrameworkWithLines";
import Features from "./Features";
import ColourLogo from "../assets/ColourLogo.svg";
import { Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";
 
const WiseUX = () => {
  return (
    <div className="scroll-smooth">
 
{/* ===========================
   HERO SECTION - 580px
=========================== */}
<section className="relative h-[60vh] flex items-center justify-center text-white overflow-hidden">
  <video
    className="absolute top-0 left-0 w-full h-full object-cover z-0"
    src="/AboutUs780.mp4"
    autoPlay
    muted
    loop
    playsInline
  />
 
  <div className="absolute inset-0 bg-gradient-to-r from-[#0A1B60] via-[#1F2E8A] to-[#4B0FA3] opacity-40 z-10" />
 
  <div className="relative z-20 max-w-7xl mx-auto px-6 text-center">
    <motion.h1
      className="text-4xl md:text-7xl font-bold"
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
    >
      DISCOVER WISSENSTIL
    </motion.h1>
 
    <motion.h2
  className="
    font-extrabold mt-4
    text-white [@media(hover:hover)]:text-transparent
  "
  style={{
    fontFamily: "Calibri, sans-serif",
    WebkitTextStroke: "2px #ffffff",
    fontSize: "3.5rem",
    lineHeight: "1",
    whiteSpace: "nowrap",
  }}
  initial={{ opacity: 0, x: -100 }}
  animate={{ opacity: 1, x: 0 }}
  transition={{ duration: 1.2 }}
>
  AI DRIVEN INNOVATOR
</motion.h2>
  </div>
</section>
 
{/* ===========================
   VISION SECTION - 580px
=========================== */}
<section className="pt-[100px] pb-12 px-6 bg-white flex flex-col items-center justify-center text-center md:text-left snap-start w-full h-auto">
  <div className="max-w-7xl w-full mx-auto flex flex-col items-center text-gray-900 text-lg md:text-2xl font-normal leading-tight space-y-10 text-center">
   
   {/* Paragraph */}
<p
   className="mt-6 max-w-3xl text-gray-700 leading-relaxed mx-auto text-center md:text-24px"
  style={{
    fontFamily: "Calibri, sans-serif",
    fontSize: "26px"  // 🔥 mobile size increased
  }}
>
  Driven by a team of AI specialists, engineers, and domain experts, we develop
  solutions that integrate seamlessly into <b>healthcare, life sciences, aerospace, and beyond</b>.
  Our goal is to bridge the gap between complex AI models and real-world applications,
  ensuring smarter decision-making and streamlined operations.
</p>

    {/* OUR VISION Block */}
    <div className="flex flex-col md:flex-row items-center justify-center space-y-6 md:space-y-0 md:space-x-8 text-center">
     
      {/* OUR VISION heading */}
      <div className="md:pl-2">        {/* <-- THIS LINE MOVES IT RIGHT ONLY IN LAPTOP VIEW */}
        <h1
          className="font-extrabold text-transparent"
          style={{
            fontFamily: "Calibri, sans-serif",
            WebkitTextStroke: "2px #9c6bff",
            fontSize: "5.5rem",
            letterSpacing: "0.05em",
            lineHeight: "1",
          }}
        >
          OUR <br /> VISION
        </h1>
      </div>
 
      {/* Description */}
      <div className="max-w-xl">
  <p
  className="w-fit mt-6 max-w-4xl text-gray-700 leading-relaxed md:text-24px
             text-start md:text-center !ms-3 md:!ms-0"
  style={{
    fontFamily: "Calibri, sans-serif",
    fontSize: "26px",
    maxWidth: "485px",
  }}
>



  To pioneer AI-driven innovation that transforms industries,
  enhances decision-making, and empowers businesses with
  intelligent, scalable, and future-ready solutions.
</p>

</div>



    </div>
   
  </div>
</section>

{/* ===========================
   MINDS BEHIND - 580px
=========================== */}
<section className="snap-start h-[580px] w-screen bg-gradient-to-r from-[#0A0E45] via-[#1E0F78] to-[#4B0EA6] text-white px-16 py-6 flex items-start justify-start">
  <div className="max-w-6xl pt-4">
    <h2 className="text-white text-3xl font-semibold">
      The <span className="text-blue-300">Minds</span> Behind Wissenstil
    </h2>
    <img src={line} alt="line" className="w-auto mt-2" />
  </div>
</section>
 
 
 
 
{/* ===========================
   INNOVATION - 580px
=========================== */}
<section id="innovation" className="snap-start h-[1100px] w-screen flex items-center justify-center bg-white px-4">
  <Innovation />
</section>
 
 <div className="w-full py-10 bg-gradient-to-r from-[#0A0E45] via-[#1E0F78] to-[#4B0EA6] flex justify-center items-center">
 
  <div className="w-full flex justify-center overflow-x-hidden">
 
    {/* Slight LEFT shift ONLY on laptop */}
<div className="min-w-[1200px] md:-translate-x-3">
<WiseFrameworkWithLines />
</div>
 
  </div>
 
</div>
 
 
 
 
<section className="w-screen snap-start bg-gradient-to-r from-[#ffffff] to-[#fffff] text-black relative overflow-hidden flex items-center justify-center h-auto py-20">
  <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center gap-10 md:gap-28 px-4">
   
    {/* Image */}
    <motion.img
      src={About2}
      alt=""
      className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-sm h-auto z-10"
      initial={{ opacity: 0, x: -50 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 1 }}
      viewport={{ once: true }}
    />
 
    {/* Text Content */}
   <div className="max-w-xl">
  <p className="font-calibri text-gray-800 text-[26px] leading-relaxed text-justify">
  WISE streamlines the process of <strong>image annotation and data labeling</strong>, reducing manual effort while accelerating AI model training. By learning from minimal user input, WISE <strong>auto-annotates images</strong>, making neural network training more efficient and scalable.
  <br /><br />
  At its core, WISE is a <strong>sophisticated collection of machine learning algorithms and optimized neural networks</strong>. This enables what we call <strong>"zero prototyping"</strong>, allowing AI experts to focus on solving complex challenges instead of spending time on exploratory tasks like selecting the right algorithm or network.
</p>

</div>
 
  </div>
</section>
 
<section className="w-screen snap-start bg-gradient-to-r from-[#ffffff] to-[#fffff] text-black relative overflow-hidden flex items-center justify-center h-auto py-20">
  <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-center gap-10 md:gap-20 px-4">
   
    {/* Text Left */}
    <div className="max-w-xl text-left">
  <p className="font-calibri text-gray-800 text-[26px] leading-relaxed text-justify">
  But WISE goes beyond deep learning. The framework integrates
  <strong> computer vision, traditional machine learning approaches, and natural language processing (NLP)</strong>
  to ensure that the most suitable technology is applied to each unique problem. This results in
  <strong> higher accuracy, adaptability, and efficiency</strong>.
  <br /><br />
  With its <strong>carefully orchestrated AI technologies</strong>, WISE powers solutions in
  <strong> image analysis, predictive modeling, anomaly detection, classification, and beyond</strong> —
  delivering intelligent automation that transforms industries.
</p>

</div>

 
 
 
 
    {/* Image Right */}
    <motion.img
      src={About3}
      alt=""
      className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-sm h-auto"
      initial={{ opacity: 0, x: 50 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 1 }}
      viewport={{ once: true }}
    />
  </div>
</section>
{/* ===========================
   FEATURES - 580px
=========================== */}
<section className="snap-start h-[580px] w-screen bg-gradient-to-r from-[#0A0E45] via-[#1E0F78] to-[#4B0EA6] text-white flex items-center justify-center pt-20">
  <Features />
</section>
 
 
 
 
 
{/* ===========================
   FOOTER - 580px
=========================== */}
{/* 🌈 Footer Curved Section */}
      <section className="relative bg-gradient-to-r from-[#050A3A] via-[#1A0F6B] to-[#3E0E9F] overflow-hidden h-auto !pb-0 !mb-0">
 
        {/* Curved white background */}
        <div className="absolute top-[160px] left-0 w-full">
          <div
            className="
              bg-white
              rounded-t-[12rem]
              sm:rounded-t-[14rem]
              min-h-[40vh]         /* reduced height—white space fix */
              sm:min-h-[60vh]
              pb-6                /* reduced padding to remove gap */
            "
          ></div>
        </div>
 
        {/* Footer Content */}
        <div className="relative z-10 px-6 sm:px-10 md:px-16 lg:px-24 pt-32 pb-10">
 
          {/* Footer heading */}
          <div className="text-center mt-[120px] mb-10">
            <h2 className="text-4xl sm:text-5xl font-bold mb-2 text-[#6F7DFF]">
              Collaborate for Success
            </h2>
            <p className="text-gray-700 text-lg sm:text-xl font-medium">
              Working together fosters innovation, creativity, and achievement.
            </p>
          </div>
 
          {/* Footer grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 text-gray-800">
 
            {/* About us */}
            <div>
              <h3 className="font-bold mb-4 text-gray-900">ABOUT US</h3>
              <img src={ColourLogo} alt="Wissenstil Solutions" className="w-40 mb-4" />
              <p className="mb-4">
                Wissenstil Solutions is a specialized software company driving digital innovation.
              </p>
            </div>
 
            {/* Services */}
            <div>
              <h3 className="font-bold mb-4 text-gray-900">SERVICES</h3>
              <ul className="space-y-2">
                <li>Image Analysis</li>
                <li>Anomaly Detection</li>
                <li>Medical Coding</li>
              </ul>
            </div>
 
            {/* Useful links */}
            <div>
              <h3 className="font-bold mb-4 text-gray-900">USEFUL LINKS</h3>
              <ul className="space-y-2">
                {[
                  { name: "About Us", path: "/about" },
                  { name: "Wise Services", path: "/services" },
                  { name: "Wise Products", path: "/products" },
                  { name: "Contact Us", path: "/contact" },
                ].map((link, index) => (
                  <li
                    key={index}
                    className="transition-transform duration-300 hover:translate-x-2"
                  >
                    <Link to={link.path} className="relative hover:text-purple-700">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
 
            {/* Contact */}
            <div>
              <h3 className="font-bold mb-4 text-gray-900">CONTACT US</h3>
              <p>
                Wissenstil Solutions Private Ltd.<br />
                Brigade IRV Centre, Floors 09 & 10,<br />
                Whitefield, Bangalore, 560066.
              </p>
 
              <div className="mt-4 space-y-3">
                <p className="flex items-center space-x-3">
                  <Phone className="w-5 h-5 text-gray-900" />
                  <span className="font-medium text-gray-900">
                    +91 9986158307
                  </span>
                </p>
 
                <p className="flex items-center space-x-3">
                  <Mail className="w-5 h-5 text-gray-900" />
                  <span className="font-medium text-gray-900">
                    Manish.palliyil@wissenstil.com
                  </span>
                </p>
              </div>
            </div>
 
          </div>
        </div>
      </section>
 
</div>
  );
};
 
export default WiseUX;